<template>
	<div>
		<AppTextField v-model="sampleCustomerEmail" placeholder="Enter sample customer email" outlined />
	</div>
</template>

<script>
import debounce from 'lodash/debounce';

import { editedWorkflowVersion } from '@/store/modules/selectedWorkflow/getters';
import { updateWorkflowVersion } from '@/store/modules/workflows/modules/versions/actions.js';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { DEFAULT_SAMPLE_CUSTOMER_EMAIL } from '@/utils/WorkflowService';

export default {
	name: 'SampleCustomerEmail',
	components: {},
	computed: {
		...mapGettersShorthand({ editedWorkflowVersion }),
		sampleCustomerEmail: {
			get() {
				return this.editedWorkflowVersion.sample_data?.customer?.email || DEFAULT_SAMPLE_CUSTOMER_EMAIL;
			},
			set: debounce(async function (value) {
				this.updateWorkflowVersion({
					workflowId: this.editedWorkflowVersion.original,
					workflowVersionId: this.editedWorkflowVersion.id,
					partialVersionObject: { sample_data: { customer: { email: value } } },
				});
			}, 1000),
		},
	},
	methods: {
		...mapActionsShorthand({ updateWorkflowVersion }),
	},
};
</script>

<style scoped></style>
